"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var reactstrap_1 = require("reactstrap");
var Types_1 = require("../../../Types");
exports.RagBadge = function (props) {
    var _a, _b;
    var content;
    var style;
    if ((_b = (_a = props.result.packInfo) === null || _a === void 0 ? void 0 : _a.State) === null || _b === void 0 ? void 0 : _b.value) {
        content = props.result.packInfo.State.displayName;
        style = { fontSize: "1.3em", lineHeight: "3rem", fontWeight: 500 };
    }
    else {
        content = React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: Types_1.GetRagIcon(props.result.ragIcon) });
        style = { fontSize: "3em" };
    }
    return React.createElement(reactstrap_1.Badge, { className: "rag-badge", style: __assign(__assign({}, style), { padding: "15px 20px", borderRadius: "5px", color: "white" }), color: Types_1.GetRagClass(props.result.ragClass), children: content });
};
//# sourceMappingURL=RagBadge.js.map